export const DOCUMENT_TYPE_FAQ = 'faq';
